import React, { useContext, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify';
import { Typography, Button, Spinner } from "@material-tailwind/react";
import { add_style_data, update_style } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { FileInput } from '../FileInput/FileInput'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '../Switch/Switch';
import ReactSelect from 'react-select';
import AnimationComponent from '../../Pages/AnimationComponent/AnimationComponent';

export const StyleModel = () => {
    const { isModalLoading, setFormData, setDeleteUpdateTag, deleteUpdateYes, handleSwitch, handleFileInput, setIsModalLoading, handleClose, formData, open, addEditDeleteTag, handleChange, setImgObj, imgObj } = useContext(NewContext);
    const [acceptFile, setAcceptFile] = useState('image');
    const [selectedViewType, setSelectedViewType] = useState({ label: "image", name: "sectionType", value: "image" });
    const stylePreview = useRef(null);

    useEffect(() => {
        if (addEditDeleteTag === 'add') {
            setFormData({ ...formData, isActive: true })
        }
    }, [addEditDeleteTag, deleteUpdateYes]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdateAiArtStyle;
        setIsModalLoading(true);

        const obj = {
            ...formData,
            styleName: formData?.styleName,
            style: formData?.style,
            stylePreview: formData?.stylePreview,
            isActive: formData?.isActive ? true : false,
            isTop: formData?.isTop ? true : false,
            isLatest: formData?.isLatest ? true : false,
            isPremium: formData?.isPremium ? true : false,
            viewType: selectedViewType.label,
        }

        if (addEditDeleteTag === `update`) {
            createUpdateAiArtStyle = await update_style(obj, formData?._id)
        } else {
            createUpdateAiArtStyle = await add_style_data(obj)
        }

        setIsModalLoading(false);
        if (createUpdateAiArtStyle) {
            const { message, status } = createUpdateAiArtStyle;
            if (status) {
                toast.success(message);
                handleClose();
                setDeleteUpdateTag(deleteUpdateYes);
                // Reset selectedViewType only on successful submission
                if (addEditDeleteTag !== `update`) {
                    setSelectedViewType({ label: "image", name: "sectionType", value: "image" });
                }
            } else {
                toast.error(message);
            };
        }
    }

    const viewTypeOptionArray = [
        { keyValue: 'image', name: 'image' },
        { keyValue: 'lottie', name: 'lottie' },
        { keyValue: 'gif', name: 'gif' },
    ];
    const viewOptionsArray = viewTypeOptionArray.map(item => ({
        value: item.keyValue,
        label: item.name,
        name: 'sectionType',
    }));

    useEffect(() => {
        if (addEditDeleteTag === 'update') {
            setSelectedViewType({ label: formData.viewType, name: "sectionType", value: formData.viewType });
            setAcceptFile(formData.viewType);
        } else {
            setSelectedViewType({ label: "image", name: "sectionType", value: "image" });
            setAcceptFile('image');
        }
    }, [addEditDeleteTag]);
    const fileRemove = (_ele, name) => {
        setFormData({ ...formData, [_ele]: undefined });
        setImgObj({ ...imgObj, [name]: undefined, [_ele]: undefined });
    };

    const getAcceptString = () => {
        switch (acceptFile) {
            case 'image':
                return 'image/jpeg,image/png,image/webp,image/jpg';
            case 'lottie':
                return 'application/json';
            case 'gif':
                return 'image/gif';
            default:
                return '';
        }
    };

    const handleSelectChange = async (selectedOption, actionMeta) => {
        const { name } = actionMeta;
        setFormData(prev => ({ ...prev, [name]: selectedOption?.value }));
        if (name === 'viewType') {
            setSelectedViewType(selectedOption);
            setAcceptFile(selectedOption.value);
            if (stylePreview.current) {
                stylePreview.current.value = '';
            }
            fileRemove('stylePreview', 'stylePreview');
        }
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "490px",
                            borderRadius: "12px"
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit Style ` : `Add tyle `
                    }

                </DialogTitle>

                <DialogContent>
                    <div>
                        {
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <div className='w-auto'>
                                        <div className="col-span-12 sm:col-span-3">
                                            <label htmlFor="viewType" className="block text-sm font-medium leading-6 text-gray-900">View Type:<span className='text-red-800'>*</span></label>
                                            <div className="mt-2">
                                                <ReactSelect required name='viewType' labelledBy='Select view Type' options={viewOptionsArray} value={selectedViewType} onChange={handleSelectChange} />
                                            </div>
                                        </div>
                                        {addEditDeleteTag === 'update' ? (
                                            <div className="pt-3">
                                                <Typography className="text-lg text-[#1E1627] font-medium">Preview :</Typography>
                                                <div className='w-auto'>
                                                    {formData.stylePreview && /\.(mp4|webm|ogg)$/i.test(formData.stylePreview) ? (
                                                        <div className="relative">
                                                            <video controls className="w-[200px] h-[200px]">
                                                                <source src={formData.stylePreview} type="video/mp4" />
                                                                Your browser does not support the video tag.
                                                            </video>
                                                            <Button
                                                                variant='filled'
                                                                className="file-remove-icon !absolute m-auto rounded-full top-2.5 right-2.5 leading-normal py-1.5 px-3 bg-[#F62929] shadow-none hover:shadow-none"
                                                                onClick={() => fileRemove('stylePreview', 'stylePreview')}
                                                            >
                                                                Remove
                                                            </Button>
                                                        </div>
                                                    ) : formData.stylePreview && /\.json$/i.test(formData.stylePreview) ? (
                                                        <div className="relative">
                                                            <AnimationComponent url={formData.stylePreview} />
                                                            <Button
                                                                variant='filled'
                                                                className="file-remove-icon !absolute m-auto rounded-full top-2.5 right-2.5 leading-normal py-1.5 px-3 bg-[#F62929] shadow-none hover:shadow-none"
                                                                onClick={() => fileRemove('stylePreview', 'stylePreview')}
                                                            >
                                                                Remove
                                                            </Button>
                                                        </div>
                                                    ) : (
                                                        <FileInput
                                                            name={`stylePreview`}
                                                            ref={stylePreview}
                                                            imgClass={`w-[200px] h-[200px]`}
                                                            previewFields={'stylePreview'}
                                                            validation={false}
                                                            accept={getAcceptString()}
                                                            acceptedExtensions={/\.(jpg|png|webp|PNG|json|mp4|webm|ogg|gif)$/}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        ) : null}

                                        {addEditDeleteTag === 'add' ? (
                                            <div className="col-span-6 sm:col-span-6 pt-3">
                                                <label htmlFor="stylePreview" className="block text-sm font-medium leading-6 text-gray-900"> <p>Upload Preview:<sup className='text-red-800'>*</sup></p> </label>
                                                <div className="mt-1.5 relative">
                                                    <input id='stylePreview' ref={stylePreview} type='file' accept={getAcceptString()} name='stylePreview' onChange={e => handleFileInput(e)} className='w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500' required />
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="grid grid-cols-6 lg:grid-cols-6 gap-5 add-edit-form mt-4">
                                    <div className="col-span-6 sm:col-span-6">
                                        <label htmlFor="styleName" className="block text-sm font-medium leading-6 text-gray-900">Style Name <span className='text-red-800'>*</span></label>
                                        <div className="mt-2">
                                            <input
                                                id='styleName'
                                                className=' w-full border px-3 py-2 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500'
                                                placeholder='Enter Style Name'
                                                name='styleName'
                                                onChange={handleChange}
                                                minLength={1}
                                                maxLength={40}
                                                type='String'
                                                min={1}
                                                value={formData?.styleName || ''}
                                                autoComplete='off'
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-span-6 sm:col-span-6">
                                        <label htmlFor="style" className="block text-sm font-medium leading-6 text-gray-900">Style <span className='text-red-800'>*</span></label>
                                        <div className="mt-2">
                                            <input
                                                id='style'
                                                className=' w-full border px-3 py-2 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500'
                                                placeholder='Enter Style Name'
                                                name='style'
                                                onChange={handleChange}
                                                minLength={1}
                                                maxLength={40}
                                                type='String'
                                                min={1}
                                                value={formData?.style || ''}
                                                autoComplete='off'
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-span-2 sm:col-span-2">
                                        <label htmlFor="isActive" className="block text-sm font-medium leading-6 text-gray-900">isActive:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isActive' name='isActive' onChange={handleSwitch} checked={formData?.isActive} />
                                        </div>
                                    </div>
                                    <div className="col-span-2 sm:col-span-2">
                                        <label htmlFor="isTop" className="block text-sm font-medium leading-6 text-gray-900">isTop:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isTop' name='isTop' onChange={handleSwitch} checked={formData?.isTop} />
                                        </div>
                                    </div>
                                    <div className="col-span-2 sm:col-span-2">
                                        <label htmlFor="isLatest" className="block text-sm font-medium leading-6 text-gray-900">isLatest:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isLatest' name='isLatest' onChange={handleSwitch} checked={formData?.isLatest} />
                                        </div>
                                    </div>
                                    <div className="col-span-2 sm:col-span-2">
                                        <label htmlFor="isPremium" className="block text-sm font-medium leading-6 text-gray-900">isPremium:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isPremium' name='isPremium' onChange={handleSwitch} checked={formData?.isPremium} />
                                        </div>
                                    </div>
                                </div>
                                <div className='flex justify-end mt-5'>
                                    <Button
                                        onClick={handleClose}
                                        className="mr-2.5 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                    >
                                        <span>Cancel</span>
                                    </Button>
                                    <Button
                                        disabled={isModalLoading}
                                        className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                        type='submit'
                                    >
                                        {isModalLoading && <Spinner className="h-4 w-4" />}
                                        <span className={isModalLoading ? 'ml-4' : ''}>{addEditDeleteTag === `update` ? `Update` : `Add`}</span>
                                    </Button>
                                </div>
                            </form>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default StyleModel
